import FeedSelector from '@components/feed-selector/feed-selector.component'
import PhotoLegend from '@components/photo-legend/photo-legend.component'
import { Button, LogService, Media, Modal, Steps } from '@hub/shared'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './modal-select-photo-legend.component.scoped.scss'
import './modal-select-photo-legend.component.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  idProfile: string | number
  selectedPhoto?: Media
  open?: boolean
  onOpenChange?: (open: boolean) => any
  onSelectPhoto?: (photo?: Media) => any
  name?: string
}

export default ({ idProfile, selectedPhoto, onSelectPhoto, onOpenChange, open = false, className = '', name = '' }: Props) => {
  const [photo, setPhoto] = useState<Media | undefined>(selectedPhoto)
  const logService = useMemo(() => new LogService(), [])
  const [step, setStep] = useState(0)
  const [t] = useTranslation('communicationPage')
  const [loading, setLoading] = useState(true)
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  logService.init('Modal Select Photo')
  const stepsModal = [{ status: 'one' }, { status: 'two' }]
  const socialNetwork = 'instagram'

  const handleOnChange = useCallback(
    (action: boolean) => {
      if (onOpenChange && typeof onOpenChange === 'function') {
        onOpenChange(action)
      }
    },
    [onOpenChange]
  )
  const confirm = useCallback(() => {
    if (step === 0) {
      setStep(1)
    }

    if (step === 1) {
      setLoadingSubmit(true)
      if (onSelectPhoto && typeof onSelectPhoto === 'function') {
        onSelectPhoto(photo)
      }
      handleOnChange(false)
    }
    setLoadingSubmit(false)
  }, [photo, step, handleOnChange, onSelectPhoto, setStep])

  useEffect(() => {
    if (open) {
      setStep(0)
      setPhoto(selectedPhoto)
    }
  }, [open, selectedPhoto])

  if (!idProfile || !open) {
    return null
  }

  return (
    <Modal
      open={open}
      onOpenChange={(open: boolean) => handleOnChange(open)}
      onCloseChange={() => handleOnChange(false)}
      className={`modal-select-photo ${className}`}
      footer={
        <div className="modal-select-photo-footer display-flex justify-content-space-between">
          <Button
            onClick={() => handleOnChange(false)}
            className="modal-select-photo-footer-button"
            color="var(--background_secondary)"
            textColor="var(--text_color)"
            borderColor="var(--border_color)"
          >
            {t('cancel')}
          </Button>
          <Button
            onClick={() => confirm()}
            loading={loadingSubmit}
            className="modal-select-photo-footer-button"
            disabled={loading || !photo}
          >
            {step === 0 ? t('modalPhoto.next') : t('modalPhoto.confirm')}
          </Button>
        </div>
      }
      header={
        <h5 className="logo-instagram mb-0">
          <i className={`fa-brands fa-${socialNetwork} mr-3`}></i>
          {step === 0 ? t('modalPhoto.step0') : t('modalPhoto.titleConfirm')}
        </h5>
      }
    >
      <Steps steps={stepsModal} active={step} />
      {step === 0 ? (
        <FeedSelector
          getOnLoading={setLoading}
          onSelectPhoto={(newPhoto) => setPhoto(newPhoto)}
          socialNetwork={socialNetwork}
          name={name}
          idProfile={idProfile}
          selectedPhoto={selectedPhoto}
        />
      ) : null}
      {step === 1 ? (
        <div className="display-flex justify-content-center pb-3">
          <PhotoLegend photo={photo!} />
        </div>
      ) : null}
    </Modal>
  )
}
